var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = { class: "flex items-center" };
var _hoisted_2 = { class: "w-full md:min-w-[360px]" };
var _hoisted_3 = {
    key: 0,
    class: "mb-6 flex items-center"
};
var _hoisted_4 = { class: "truncate flex items-center" };
var _hoisted_5 = ["src"];
var _hoisted_6 = { class: "ml-2.5" };
var _hoisted_7 = {
    key: 0,
    class: "ml-8 py-1.5 px-2.5 bg-gray-100 text-gray-500 rounded-md shrink-0"
};
var _hoisted_8 = {
    key: 1,
    class: "mb-7 text-xl font-medium"
};
var _hoisted_9 = { class: "mt-5 lg:hidden" };
var _hoisted_10 = { class: "text-base" };
var _hoisted_11 = { class: "mt-4" };
var _hoisted_12 = {
    key: 1,
    class: "w-full"
};
var _hoisted_13 = { class: "mt-2" };
var _hoisted_14 = {
    key: 0,
    class: "bg-primary bg-opacity-10 text-primary ring-primary/30 py-4 px-4.5 rounded-lg my-2.5"
};
var _hoisted_15 = { class: "font-medium" };
var _hoisted_16 = {
    key: 1,
    class: "w-full flex space-x-2.5 mt-2.5"
};
var _hoisted_17 = { class: "font-normal underline" };
var _hoisted_18 = { class: "hidden lg:flex" };
var _hoisted_19 = { class: "text-base" };
var _hoisted_20 = { class: "flex lg:hidden" };
var _hoisted_21 = { class: "text-base" };
var _hoisted_22 = { class: "mt-7" };
var _hoisted_23 = { class: "text-gray-400" };
var _hoisted_24 = {
    class: "hover:underline",
    href: "/docs/policy",
    target: "_blank"
};
var _hoisted_25 = {
    class: "hover:underline",
    href: "/docs/oferta",
    target: "_blank"
};
var _hoisted_26 = {
    key: 1,
    class: "hover:underline",
    href: "/docs/policy",
    target: "_blank"
};
import { ref, computed, watch, onBeforeUnmount, onMounted } from 'vue';
import PaymentOption from '@common/components/Landing/OrderForm/components/PaymentOption.vue';
import { isLinkIcon } from '@common/utils/Helpers/Helpers';
import Auth from '@common/modules/auth';
import { primaryStyles } from '@common/utils/Colors/Colors';
import { getCurrencyByCode } from '@common/utils/Currencies/Currencies';
import { isMobile } from '@common/utils/Crossbrowser';
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import ECheckboxField from '@common/ui/EForm/fields/ECheckboxField.vue';
import EInputField from '@common/ui/EForm/fields/EInputField.vue';
import ELabel from '@common/ui/ELabel.vue';
import EInputPhoneField from '@common/ui/EForm/fields/EInputPhoneField.vue';
import { useI18n } from 'vue-i18n';
import { isValidPhoneNumberV2 } from '@common/ui/EInputPhone/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrderForm',
    props: {
        visible: { type: Boolean },
        landing: {},
        plan: {},
        course: {},
        userFieldsValues: {},
        canUsePromoCodes: { type: Boolean },
        loadingCheckDiscount: { type: Boolean },
        promocode: {},
        forceShowEmailField: { type: Boolean },
        purchaseLoading: { type: Boolean }
    },
    emits: {
        hide: function () { return true; },
        formSubmit: function (_fields) { return true; },
        checkDiscount: function (_code) { return true; },
    },
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var t = useI18n().t;
        var hasDiscount = ref(false);
        var step = ref('form');
        var _b = useForm({
            validationSchema: toTypedSchema(z.object({
                email: (props.forceShowEmailField || Auth.isGuest()) ? z.string().email().min(1, t('form.emailRequired')) : z.string(),
                discount: z.string(),
                payment: z.union([
                    z.literal('acquiring'),
                    z.literal('installment'),
                ]),
                policy: z.boolean().refine(function (v) { return v; }, t('form.policyRequired')),
                customFields: z.record(z.string(), z.union([
                    z.string().superRefine(function (value, ctx) {
                        var fieldId = ctx.path[1];
                        var field = filteredCustomFields.value.find(function (f) { return f.id === fieldId; });
                        if ((field === null || field === void 0 ? void 0 : field.type) === 'phone' && !isValidPhoneNumberV2(value)) {
                            ctx.addIssue({
                                code: z.ZodIssueCode.custom,
                                message: t('form.phoneError'),
                                path: ctx.path
                            });
                        }
                    }),
                    z.number()
                ]))
            })),
            keepValuesOnUnmount: true,
            initialValues: {
                email: '',
                payment: 'acquiring',
                discount: '',
                policy: false,
                customFields: {}
            }
        }), values = _b.values, setValues = _b.setValues, errors = _b.errors, handleSubmit = _b.handleSubmit;
        var customFields = computed(function () {
            return props.landing.userFields ? props.landing.userFields.map(function (el) { return el.field; }) : null;
        });
        var landingCurrency = computed(function () {
            return getCurrencyByCode(props.landing.currency);
        });
        var styles = computed(function () {
            var primaryColor = props.landing && props.landing.primaryColor ? props.landing.primaryColor : '#17b198';
            return primaryStyles(primaryColor);
        });
        var filteredCustomFields = computed(function () {
            if (!customFields.value)
                return [];
            if (!props.userFieldsValues)
                return customFields.value;
            var mappedCustomFields = customFields.value.map(function (el) {
                var field = props.userFieldsValues.find(function (f) { return f.field === el.id; });
                if (field) {
                    return __assign(__assign({}, el), { value: field.value });
                }
                return el;
            });
            return mappedCustomFields.filter(function (el) {
                return !props.userFieldsValues.map(function (f) { return f.field; }).includes(el.id) || !el.value;
            });
        });
        var isFree = computed(function () {
            var _a, _b;
            return props.landing.plansPayment ? ((_a = props.plan) === null || _a === void 0 ? void 0 : _a.price) === 0 : ((_b = props.landing) === null || _b === void 0 ? void 0 : _b.price) === 0;
        });
        var showTreaty = computed(function () {
            return !window.__passdata.dontUseDogovor;
        });
        var sitsLeft = computed(function () {
            if (!props.plan) {
                return null;
            }
            var group = props.plan.group;
            if (!group || group.limitStudents === null) {
                return null;
            }
            var leftPlaces = group.limitStudents - group.studentsCount;
            return leftPlaces < 0 ? 0 : leftPlaces;
        });
        // Если рассрочка поддерживается
        var isInstallmentExists = computed(function () {
            return props.course.paymentInstallmentGateway !== null;
        });
        watch(filteredCustomFields, function (val, oldVal) {
            var e_1, _a;
            if (val.length > 0 && !oldVal) {
                var newFields = {};
                try {
                    for (var val_1 = __values(val), val_1_1 = val_1.next(); !val_1_1.done; val_1_1 = val_1.next()) {
                        var field = val_1_1.value;
                        newFields[field.id] = '';
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (val_1_1 && !val_1_1.done && (_a = val_1.return)) _a.call(val_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                setValues({
                    customFields: newFields
                }, false);
            }
        });
        onMounted(function () {
            if (isMobile()) {
                setValues({
                    policy: true
                }, false);
            }
        });
        onBeforeUnmount(function () {
            hide();
        });
        var hide = function () {
            emit('hide');
        };
        var checkDiscount = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                emit('checkDiscount', values.discount);
                return [2 /*return*/];
            });
        }); };
        var applyDiscount = function () {
            hasDiscount.value = true;
        };
        var submitForm = handleSubmit(function (values, ctx) {
            var customFields = values.customFields, otherData = __rest(values, ["customFields"]);
            emit('formSubmit', __assign(__assign({}, otherData), { customFields: customFields }));
        });
        var changePayment = function (option) {
            setValues({
                payment: option
            }, false);
        };
        var goForm = function () {
            step.value = 'form';
        };
        var goPayment = handleSubmit(function () {
            step.value = 'payment';
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                visible: _ctx.visible,
                name: "order-form",
                size: "fitContent",
                "append-to-body": "",
                "center-content": "",
                onClose: hide
            }, {
                default: _withCtx(function () {
                    var _a, _b, _c, _d;
                    return [
                        _createElementVNode("div", {
                            style: _normalizeStyle(styles.value)
                        }, [
                            _createElementVNode("div", _hoisted_1, [
                                (!isFree.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass([[
                                                step.value === 'payment' ? '' : 'hidden lg:block'
                                            ], "px-10 py-8 bg-gray-50 rounded-lg"])
                                    }, [
                                        _createElementVNode("div", _hoisted_2, [
                                            (_ctx.plan)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                    _createElementVNode("div", _hoisted_4, [
                                                        (_ctx.plan.image && !_unref(isLinkIcon)(_ctx.plan.image))
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: _ctx.plan.image,
                                                                alt: "",
                                                                class: "w-4 h-4"
                                                            }, null, 8, _hoisted_5))
                                                            : (_ctx.plan.image && _unref(isLinkIcon)(_ctx.plan.image))
                                                                ? (_openBlock(), _createBlock(_component_e_icon, {
                                                                    key: 1,
                                                                    icon: _ctx.plan.image,
                                                                    class: "w-4 h-4 text-primary",
                                                                    public: ""
                                                                }, null, 8, ["icon"]))
                                                                : (_openBlock(), _createBlock(_component_e_icon, {
                                                                    key: 2,
                                                                    class: "w-4 h-4 text-primary",
                                                                    icon: "image-stack"
                                                                })),
                                                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.plan.title), 1)
                                                    ]),
                                                    (sitsLeft.value !== null)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('payment.sitsLeft', { sitsLeft: sitsLeft.value })), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (isInstallmentExists.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('payment.selectPaymentOption')), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", null, [
                                                (((_a = _ctx.plan) === null || _a === void 0 ? void 0 : _a.price) || ((_b = _ctx.landing) === null || _b === void 0 ? void 0 : _b.price))
                                                    ? (_openBlock(), _createBlock(PaymentOption, {
                                                        key: 0,
                                                        currency: _ctx.landing.currency,
                                                        "hide-radio": !isInstallmentExists.value,
                                                        price: _ctx.plan ? _ctx.plan.price : _ctx.landing.price,
                                                        "price-old": _ctx.plan ? _ctx.plan.priceOld : _ctx.landing.priceOld,
                                                        promocode: _ctx.promocode,
                                                        selected: isInstallmentExists.value && _unref(values).payment === 'acquiring',
                                                        type: "acquiring",
                                                        onClick: _cache[0] || (_cache[0] = function ($event) { return (changePayment('acquiring')); })
                                                    }, null, 8, ["currency", "hide-radio", "price", "price-old", "promocode", "selected"]))
                                                    : _createCommentVNode("", true),
                                                (isInstallmentExists.value && (((_c = _ctx.plan) === null || _c === void 0 ? void 0 : _c.price) || ((_d = _ctx.landing) === null || _d === void 0 ? void 0 : _d.price)))
                                                    ? (_openBlock(), _createBlock(PaymentOption, {
                                                        key: 1,
                                                        currency: _ctx.landing.currency,
                                                        price: _ctx.plan ? _ctx.plan.price : _ctx.landing.price,
                                                        "price-old": _ctx.plan ? _ctx.plan.priceOld : _ctx.landing.priceOld,
                                                        promocode: _ctx.promocode,
                                                        selected: _unref(values).payment === 'installment',
                                                        class: "mt-5",
                                                        type: "installment",
                                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (changePayment('installment')); })
                                                    }, null, 8, ["currency", "price", "price-old", "promocode", "selected"]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_component_e_button, {
                                                disabled: _ctx.purchaseLoading,
                                                loading: _ctx.purchaseLoading,
                                                class: "w-full",
                                                size: "large",
                                                type: "primary",
                                                onClick: _unref(submitForm)
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('payment.submitForm', { paymentType: _unref(values).payment })), 1)
                                                ]; }),
                                                _: 1
                                            }, 8, ["disabled", "loading", "onClick"]),
                                            _createVNode(_component_e_button, {
                                                class: "mt-4 w-full",
                                                type: "secondary",
                                                onClick: goForm
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createTextVNode(_toDisplayString(_unref(t)('payment.back')), 1)
                                                ]; }),
                                                _: 1
                                            })
                                        ])
                                    ], 2))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: _normalizeClass([[
                                            step.value === 'form' ? '' : 'hidden lg:block'
                                        ], "mx-10 py-8 w-full md:w-[390px]"])
                                }, [
                                    _createElementVNode("p", {
                                        class: _normalizeClass([[
                                                isFree.value && 'text-center'
                                            ], "max-w-xl font-medium text-lg md:text-2xl"])
                                    }, _toDisplayString(_ctx.landing.orderTitle), 3),
                                    (_ctx.landing.orderSubtitle)
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 0,
                                            class: _normalizeClass([[
                                                    isFree.value && 'text-center'
                                                ], "mt-4 max-w-lg text-base font-medium text-center"])
                                        }, _toDisplayString(_ctx.landing.orderSubtitle), 3))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", null, [
                                            (_ctx.forceShowEmailField || _unref(Auth).isGuest())
                                                ? (_openBlock(), _createBlock(ELabel, {
                                                    key: 0,
                                                    class: "w-full",
                                                    label: "Email",
                                                    name: "email"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(EInputField, {
                                                            placeholder: _unref(t)('form.emailPlaceholder'),
                                                            plugins: ['trim'],
                                                            name: "email",
                                                            size: "large"
                                                        }, null, 8, ["placeholder"])
                                                    ]; }),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCustomFields.value, function (field) {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: field.id,
                                                    class: "mt-2.5"
                                                }, [
                                                    _createVNode(ELabel, {
                                                        label: field.title,
                                                        name: "customFields.".concat(field.id)
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            (field.type === 'phone')
                                                                ? (_openBlock(), _createBlock(EInputPhoneField, {
                                                                    key: 0,
                                                                    name: "customFields.".concat(field.id),
                                                                    size: "large"
                                                                }, null, 8, ["name"]))
                                                                : (_openBlock(), _createBlock(EInputField, {
                                                                    key: 1,
                                                                    name: "customFields.".concat(field.id),
                                                                    placeholder: field.placeholder || field.title,
                                                                    size: "large"
                                                                }, null, 8, ["name", "placeholder"]))
                                                        ]; }),
                                                        _: 2
                                                    }, 1032, ["label", "name"])
                                                ]));
                                            }), 128)),
                                            (hasDiscount.value && _ctx.canUsePromoCodes)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('form.promoCode')), 1),
                                                    (_ctx.promocode)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(values).discount), 1),
                                                            _createTextVNode(" — " + _toDisplayString(_unref(t)('form.discountText')) + " " + _toDisplayString(_ctx.promocode.discount) + _toDisplayString(_ctx.promocode.discountType === 'percent' ? '%' : landingCurrency.value.symbol), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (!_ctx.promocode)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                            _createVNode(EInputField, {
                                                                placeholder: _unref(t)('form.promoCodePlaceholder'),
                                                                class: "flex-1",
                                                                name: "discount",
                                                                size: "large",
                                                                theme: "gray",
                                                                onKeyup: _withKeys(checkDiscount, ["enter"])
                                                            }, null, 8, ["placeholder"]),
                                                            _createVNode(_component_e_button, {
                                                                loading: _ctx.loadingCheckDiscount,
                                                                class: "flex-none h-12 self-end",
                                                                size: "medium",
                                                                type: "primary-alt",
                                                                onClick: checkDiscount
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createTextVNode(_toDisplayString(_unref(t)('form.activate')), 1)
                                                                ]; }),
                                                                _: 1
                                                            }, 8, ["loading"])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (!hasDiscount.value && _ctx.canUsePromoCodes && !isFree.value)
                                                ? (_openBlock(), _createBlock(_component_e_button, {
                                                    key: 2,
                                                    class: "mt-5 text-primary",
                                                    size: "nosize",
                                                    type: "text",
                                                    onClick: applyDiscount
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('form.havePromoCode')), 1)
                                                    ]; }),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createVNode(_component_e_button, {
                                                disabled: _ctx.purchaseLoading,
                                                loading: _ctx.purchaseLoading,
                                                class: "mt-7 w-full",
                                                size: "large",
                                                onClick: _unref(submitForm)
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("span", _hoisted_19, _toDisplayString(isFree.value ? _unref(t)('form.signup') : _unref(values).payment === 'acquiring' ? _unref(t)('form.signupAndPay') : _unref(t)('form.proceedToCheckout')), 1)
                                                ]; }),
                                                _: 1
                                            }, 8, ["disabled", "loading", "onClick"])
                                        ]),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createVNode(_component_e_button, {
                                                disabled: _ctx.purchaseLoading,
                                                loading: _ctx.purchaseLoading,
                                                class: "mt-7 w-full",
                                                size: "large",
                                                onClick: _cache[2] || (_cache[2] = function ($event) { return (isFree.value ? _unref(submitForm)() : _unref(goPayment)()); })
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("span", _hoisted_21, _toDisplayString(isFree.value ? _unref(t)('form.signup') : _unref(values).payment === 'acquiring' ? _unref(t)('form.continue') : _unref(t)('form.proceedToCheckout')), 1)
                                                ]; }),
                                                _: 1
                                            }, 8, ["disabled", "loading"])
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createVNode(ECheckboxField, { name: "policy" }, {
                                                default: _withCtx(function () { return [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _createTextVNode(_toDisplayString(_unref(t)('form.policyAgreement')) + " ", 1),
                                                        (showTreaty.value)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createElementVNode("a", _hoisted_24, _toDisplayString(_unref(t)('form.personalDataPolicy')) + ", ", 1),
                                                                _createTextVNode(" и "),
                                                                _createElementVNode("a", _hoisted_25, _toDisplayString(_unref(t)('form.offerAgreement')), 1)
                                                            ], 64))
                                                            : (_openBlock(), _createElementBlock("a", _hoisted_26, _toDisplayString(_unref(t)('form.personalDataPolicy')), 1))
                                                    ])
                                                ]; }),
                                                _: 1
                                            })
                                        ])
                                    ])
                                ], 2)
                            ])
                        ], 4)
                    ];
                }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
